<template>
	<div class="row">
    <loading  :active.sync="isLoading" 
              :can-cancel="false" 
              :is-full-page="true">
    </loading>
		<div class="col-md-12">
			<h4 class="title" style="margin-top:0px">Création d'une requête </h4>
		</div>
		<div class="col-md-12 card">
			<div class="card-body">
				<div class="row">
					<div class="col-lg-5 mx-auto" v-if="!cid">
						<center>Client :<br></center>
						<el-select class="my-1 information-line-text col-12" filterable v-model="requete.cid" placeholder="Choisir un client" required>
							<el-option
								v-for="item in clients"
								:key="item.cid"
								:label="item.company"
								:value="Number(item.cid)">
							</el-option>
						</el-select>
					</div>
					<div class="col-lg-5 mx-auto" v-if="cid">
						<center>Client : <br><b>{{client.company}}</b></center>
					</div>
				</div>
        <div class="row my-5">
					<div class="col-lg-5 mx-auto">
						<center>Origine :<br></center>
						<el-select class="my-1 information-line-text col-12" filterable v-model="requete.origine" placeholder="Choisir l'origine" required>
							<el-option
                v-if="rid == 1"
								label="Administration"
								value="3">
							</el-option>
							<el-option
								label="Commercial"
								value="2">
							</el-option>
							<el-option
								label="Client"
								value="1">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="row my-5">
					<div class="col-lg-5 mx-auto">
						<center>Objet : <br></center>
						<el-input class="col-12" v-model="requete.objet" required/>
					</div>
				</div>
				<div class="row my-5">
					<div class="col-lg-5 mx-auto" >
						<center>Requête : <br></center>
						<el-input type="textarea" class="col-12" :rows="5" v-model="requete.requete" required/>
					</div>
				</div>
				<div class="row my-5">
					<div class="col-lg-5 mx-auto" >
						<el-button @click="saveRequete()" type="success" class="btn-action col-12">Enregistrer</el-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  import Vue from 'vue'
  import {Button, ButtonGroup, Input, Select, Option} from 'element-ui'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import swal from 'sweetalert2'
  import Loading from 'vue-loading-overlay'
  import VueJwtDecode from 'vue-jwt-decode'

  Vue.use(Button)
  Vue.use(ButtonGroup)
  Vue.use(Input)
  Vue.use(Select)
  Vue.use(Option)
  export default {
    components: {
      Loading,
      VueJwtDecode
    },
    props: {

    },
    computed: {
    },
    data() {
      return {
        isLoading: true,
        clients: [],
        client: [],
				requete: {
        },
        cid: this.$route.params.cid,
        rid: VueJwtDecode.decode(localStorage.getItem('token')).id.rid
      }
    },
    methods: {
     	async getClients() {
        const self = this;
        const response = await fetch(this.$api_url+'/clients', {
          method: 'GET',
          credentials: 'include',
        });
        if(response.ok) { 
          const json = await response.json();
          //check if api return regenerated token
          if(json.code != 409) {
            self.log_api("success",'GET /clients', '', json)
            Object.keys(json).forEach(function (key) {
              self.clients.push(json[key])
            })
            this.isLoading = false
            return json
          }
        }
        this.isLoading = false
			},
			async getClient() {
        const self = this;
        const response = await fetch(this.$api_url+'/clients/'+this.cid, {
          method: 'GET',
          credentials: 'include',
        });
        if(response.ok) { 
          const json = await response.json();
          if(json.code != 409) {
            self.log_api("success",'GET /clients/'+self.cid, '', json)
            json.etat_comptable = json.situation_comptable != "" ? "Débiteur" : "OK" 
            this.client = json
          }
        }
        this.isLoading = false
      },
      async saveRequete() {
        this.isLoading = true
        const params = this.JSON_to_URLEncoded(this.requete);

        const response = await fetch(this.$api_url+'/requetes', {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
          body: params
        });
        const self = this;
        const json = await response.json();
        if("id" in json) {
            self.log_api("success",'POST /requetes',params, json)
          //SUCCESS PUT CLIENT
          this.notifyVue('top','center', 'success', 'Requête créée! 😄', 'fa fa-thumbs-up')
          this.$router.go(-1)
        } else {
          self.log_api("error",'POST /requetes',params, json)
          if(json.code == 400) {
            this.notifyVue('top','center', 'danger', json.message, 'fa fa-thumbs-down')
          } else {
            this.notifyVue('top','center', 'danger', 'Problème lors de la création! 😱', 'fa fa-thumbs-down')
          }
          //ERROR PUT CLIENT
          this.isLoading = false;
        } 
      },
      JSON_to_URLEncoded(obj, prefix) {
        var str = [],
          p;
        for (p in obj) {
          if (obj.hasOwnProperty(p)) {
            var k = prefix ? prefix + "[" + p + "]" : p,
              v = obj[p];
            str.push((v !== null && typeof v === "object") ?
              this.JSON_to_URLEncoded(v, k) :
              encodeURIComponent(k) + "=" + encodeURIComponent(v));
          }
        }
        return str.join("&");
      },
      notifyVue (verticalAlign, horizontalAlign, color, message, icon) {
        this.$notify(
          {
            message: message,
            icon: icon,
            horizontalAlign: horizontalAlign,
            verticalAlign: verticalAlign,
            type: color
          })
      },
    },
    
    created() {
			if(!this.cid) {
				this.getClients();
			} else {
				this.getClient();
				this.requete.cid = this.cid;
			}
    },
  }
</script>

<style>
</style>

